import { useState } from "react";
import * as S from "./styles.ts";
import { H4, P, UniversalLink } from "@template/components";
import ThumbsUp from "@template/icons/ThumbsUp.tsx";
import ThumbsDown from "@template/icons/ThumbsDown.tsx";

export const Vote = ({
  id,
  voteValue: initialVoteValue,
}: {
  id: number;
  voteValue: number | null;
}) => {
  const [voteValue, setVoteValue] = useState<number | null>(initialVoteValue);

  const handleVote = (value: 10 | 0) => {
    if (voteValue !== null) return;
    setVoteValue(value);
    fetch(`/api/article/vote?id=${id}`, {
      method: "put",
      body: JSON.stringify({ vote: value }),
    })
      .then((r) => {
        if (r.ok) {
          r.json().then((data) => {
            const voteValue = data.vote;
            const articleId = data.article_id;
            document.cookie = `article_vote_${articleId}=${voteValue}; path=/`;
          });
        }
      })
      .catch((err) => {
        console.log(err);
        setVoteValue(null);
      });
  };

  return (
    <S.VoteContainer>
      <H4>Did you find this helpful?</H4>

      {voteValue === 0 ? (
        <S.ContactText>
          <P $small={true}>
            {" "}
            Email us at{" "}
            <UniversalLink
              href="mailto:help@yay.com"
              title="Link to email help@yay.com"
            >
              help@yay.com
            </UniversalLink>{" "}
          </P>
        </S.ContactText>
      ) : (
        <S.VoteButtonContainer>
          <S.VoteButton
            onClick={() => handleVote(10)}
            $active={voteValue === 10}
          >
            <ThumbsUp />
          </S.VoteButton>
          <S.VoteButton
            onClick={() => handleVote(0)}
            disabled={voteValue === 10}
          >
            <ThumbsDown />
          </S.VoteButton>
        </S.VoteButtonContainer>
      )}
    </S.VoteContainer>
  );
};
